// internationalization
import type { TFunction } from 'i18next';

// api
import type { EnergyGroupType } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// shared components
import type { DanishAddressFieldValue } from '@/components/ui/form';

// libraries
import { z } from 'zod';

/** The only types selectable from the DeepDive creation form (Portfolio* types are created elsewhere). */
export const ENERGY_GROUP_TYPE_OPTIONS = [
  'Power',
  'Heat',
  'Water',
] as const satisfies readonly Extract<
  EnergyGroupType,
  'Power' | 'Heat' | 'Water'
>[];

export function createEnergyGroupFormSchema(t: TFunction) {
  return z.object({
    name: z.string().min(1, t('input.required', { ns: 'validation' })),
    type: z.enum(ENERGY_GROUP_TYPE_OPTIONS, {
      message: t('input.required', { ns: 'validation' }),
    }),
    location: z
      .custom<DanishAddressFieldValue>()
      .refine(
        (value) =>
          Boolean(value?.displayName?.trim()) &&
          Number.isFinite(value?.latitude) &&
          Number.isFinite(value?.longitude),
        { message: t('input.required', { ns: 'validation' }) },
      ),
  });
}

export type CreateEnergyGroupFormValues = z.infer<
  ReturnType<typeof createEnergyGroupFormSchema>
>;
